module.exports = __webpack_public_path__ + "img/art-31.9f0d0d7d.png";